import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontalCircle20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFlipHorizontalCircle20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M4.981 12.251a5.5 5.5 0 0 0 10.038 0h1.61a7.002 7.002 0 0 1-13.258 0zm13.27-2.991a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5zM10 3a7 7 0 0 1 6.629 4.75h-1.61a5.5 5.5 0 0 0-10.038 0h-1.61A7 7 0 0 1 10 3.001"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontalCircle20);
